import { render, staticRenderFns } from "./materials-cart-button.vue?vue&type=template&id=d40f091a"
import script from "./materials-cart-button.vue?vue&type=script&lang=js"
export * from "./materials-cart-button.vue?vue&type=script&lang=js"
import style0 from "../core/icons.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./materials-cart-button.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports